import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import moment from 'moment';

import LogCards from './LogCards.js';
import LogCardModal from './LogCardModal.js';
import Utils from 'utils/Utils.js';
import UserUtils from 'utils/UserUtils.js';
import DatabaseService from 'services/DatabaseService.js';
import {SET_LOADING_OVERLAY_ENABLE} from 'actions/types';

class LogCardContainer extends Component {
    constructor(props) {
        super(props);
        var selectedCategory = this.props.selectedCategory;
        this.state = {selectedCategory:selectedCategory,
                      open:Boolean(selectedCategory),
                      saving:false,
                      saved:false,
                      selectedChallenge:null,
                      indexedChallenges:{},
                      inputText:''};
        this.onLaunch = this.onLaunch.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onContinue = this.onContinue.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeNumber = this.onChangeNumber.bind(this);
        this.onChangeDateTime = this.onChangeDateTime.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onSelectCategory = this.onSelectCategory.bind(this);
        this.onSelectChallenge = this.onSelectChallenge.bind(this);
        this.loadCategory = this.loadCategory.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onUploadPhoto = this.onUploadPhoto.bind(this);
        this.onConfirmPhoto = this.onConfirmPhoto.bind(this);
    }

    componentWillMount() {
        if(this.state.selectedCategory) {
            this.loadCategory(this.state.selectedCategory);
        }
    }

    componentDidMount () {
    }

    componentWillUnmount () {
    }

    onLaunch() {
        this.setState({open:true, saving: false, saved:false,});
    }

    onClose() {
        this.close();
        if(this.props.match.path!=='/home') {
            this.props.history.push('/home');
        }
    }

    onContinue() {
        this.close();
        this.props.history.push('/myprogress');
    }

    close() {
        this.setState({open:false, saving: false, saved:false, inputText:'', selectedCategory: null, selectedChallenge:null, indexedChallenges:{}});
    }

    onChange(event) {
        var name  = event.target.name;
        var value = event.target.value;
        this.setState(state => (Utils.set({...state}, name, value)));
    }
    onChangeNumber(event) {
        var name  = event.target.name;
        var value = event.target.value;
        if(value === '' || Number(value) > 0) {
            this.setState(state => (Utils.set({...state}, name, value)));
        }
    }
    onChangeDateTime(name, datetime) {
        var value = datetime ? datetime.toISOString() : '';//'2018-05-07T11:16:20.647-0400';
        this.setState(state => (Utils.set({...state}, name, value)));
    }
    onBlur(event) {
        this.setState(state => {
            var update = {};
            var caloriesQuestionIndex = null;
            var caloriesQuestion = null;
            var durationQuestion = null;
            var challengeQuestions = Utils.deref(state, 'selectedChallenge.challengeQuestions') || [];
            for(var i = 0; i < challengeQuestions.length; i++) {
                var question = challengeQuestions[i];

                if(question.key==='calories') {
                    caloriesQuestionIndex = i;
                    caloriesQuestion = question;
                }

                if(question.key==='duration') {
                    durationQuestion = question;
                }

            }
            if(caloriesQuestionIndex!==null && durationQuestion!==null) {
                if(caloriesQuestion.data===null || caloriesQuestion.data===undefined || caloriesQuestion.data==='') {
                    var updateField = 'selectedChallenge.challengeQuestions.' + caloriesQuestionIndex + '.data'; 
                    var calories = durationQuestion.data*5;
                    update = Utils.set({...state}, updateField, calories);
                }
            }
            return update;
        });
    }
    onToggle(event, {name, checked}) {
        this.setState(state => (Utils.set({...state}, name, checked)));
    }
/*
    onChangeDropdown(event, {value, name}) {
        this.setState(state => (Utils.set({...state}, name, value)));
    }
*/

    onSelectChallenge(event, {value, name}) {
        this.setState(state => ({selectedChallenge: {...state.indexedChallenges[value]}}));
    }

    onSelectCategory(category) {
        if(this.state.selectedCategory && this.state.selectedCategory.id===category.id) {
            return;
        }

        this.setState({selectedCategory:category, selectedChallenge:null, indexedChallenges:{}, open:true, saving: false, saved:false},
            ()=>{
                if(category) {
                    this.loadCategory(category);
                }
            });
    }

    onUploadPhoto(uploadPhotoProps) {
        this.setState({uploadPhotoProps:uploadPhotoProps});
    }

    onCancelPhoto = (photo) => {
        this.setState(state => { 
                let s = {...state};
                Utils.set(s, photo, '');
                return s;
        });
    }

    onConfirmPhoto(propertyName, photo) {
        this.setState(state => {
            let s = Utils.set({...state}, propertyName, photo);
            let imagePathSplit = propertyName.split('.')
            let imagePath = imagePathSplit.filter((x,i)=> i<imagePathSplit.length-1).join('.');
            s = Utils.set({...s}, imagePath+'.enabled', true);
            console.log('onConfirmPhoto', imagePath, propertyName);
            return s;
        });
    }

    hasPhotos(challenge) {
        challenge = challenge || {};
        var questions = challenge.challengeQuestions || [];
        questions = questions.filter(question => question.dataType==6);
        return questions.length>0;
    }

    loadCategory(category) {
        DatabaseService.fetchLogCategory(category.id)
            .then(result => {
                this.setState(state => {
                    var newCategory = result.category;
                    var firstChallenge = (newCategory && newCategory.challenges && newCategory.challenges.length>0) ? newCategory.challenges[0] : null;
                    var sameCategory = (state.selectedCategory && state.selectedCategory.id===category.id);
                    var challenges = newCategory.challenges || [];
                    var indexedChallenges = challenges.reduce((m,c)=>{m[c.id]=c;return m;}, {});
                    return sameCategory ?  { selectedCategory  : newCategory,
                                             indexedChallenges : indexedChallenges,
                                             selectedChallenge : firstChallenge } : {};
                });
            })
            .catch(error => {
                console.error(error);
                window.alert('Error:' + error);
            });
    }



/*
{
    "challengeId": 89964,
    "activity": {
        "questions": [{
            "key": "start_time",
            "answers": [{
                "data": "2018-05-07T11:16:20.647-0400"
            }]
        }, {
            "key": "duration",
            "answers": [{
                "data": "123"
            }]
        }, {
            "key": "calories",
            "answers": [{
                "data": "615"
            }]
        }, {
            "key": "notes",
            "answers": [{
                "data": "Notes"
            }]
        }, {
            "key": "privacy",
            "answers": [{
                "data": "1"
            }]
        }]
    }
}
*/
    questionFilter(question) {
        return (question.data!==null && 
                question.data!=='');
    }

    mapQuestionToAnswer(question) {
        return ({key:question.key, answers:[{data:question.data}]});
    }

    isValid() {
        var selectedChallenge = this.state.selectedChallenge;
        if(!selectedChallenge) {
            return false;
        }
        var challengeQuestions = selectedChallenge.challengeQuestions;
        var formHasData = false;
        for(let i = 0; i < challengeQuestions.length; i++) {
            let challengeQuestion = challengeQuestions[i];
            let hasData = Boolean(challengeQuestion.data!==null && challengeQuestion.data!==undefined && challengeQuestion.data!=='');
            formHasData = formHasData || hasData;
            if(!challengeQuestion.optional && !hasData) {
                return false;
            }
        }
    
        return formHasData;
    }

    onSubmit() {
        if(this.isValid()) {
            var selectedChallenge = this.state.selectedChallenge;
            if(selectedChallenge) {
                var questions = selectedChallenge.challengeQuestions.filter(this.questionFilter).map(this.mapQuestionToAnswer);
                this.props.dispatch({type:SET_LOADING_OVERLAY_ENABLE, enable:true});
                this.setState({saving:true});
                DatabaseService.completeActivity(selectedChallenge.id, {questions: questions})
                    .then(result => {
                        this.setState({saved:result});
                    })
                    .catch((error)=> {
                        console.error('ERROR:');
                        console.error(error);
                        window.alert("Error: " + error);
                    })
                    .then(()=>{
                        this.props.dispatch({type:SET_LOADING_OVERLAY_ENABLE, enable:false});
                    });
            }
        }
    }

    render() {
        //console.log('render adjustments');
        var avatarUrl = this.props.userProfile ? UserUtils.getAvatarURL(this.props.userProfile) : null;
        
        var pointsEarned = 0;
        if(this.state.selectedChallenge) {
            pointsEarned = this.state.selectedChallenge.points;
            var challengeQuestions = this.state.selectedChallenge.challengeQuestions;
            for(var i = 0; i < challengeQuestions.length; i++) {
                if(challengeQuestions[i].dataType!==6) {
                    pointsEarned += challengeQuestions[i].points;
                }
            }
        }
        
        return <LogCards 
                    avatarUrl={avatarUrl}
                    open={this.state.open}
                    hide={this.state.open}
                    inline
                    categories={this.props.categories}
                    onLaunch={this.onLaunch}
                    onClose={this.onClose}
                    onSelectCategory={this.onSelectCategory}>
                    {this.state.open &&
                        <LogCardModal 
                            avatarUrl={avatarUrl}
                            open={this.state.open}
                            pointsEarned={pointsEarned}
                            uploadPhotoProps={this.state.uploadPhotoProps}
                            modalContentMaxHeight={this.state.modalContentMaxHeight}
                            categories={this.props.categories}
                            saving={this.state.saving}
                            saved={this.state.saved}
                            hasPhotos={this.hasPhotos(this.state.selectedChallenge)}
                            selectedCategory={this.state.selectedCategory}
                            selectedChallenge={this.state.selectedChallenge}
                            onLaunch={this.onLaunch}
                            onUploadPhoto={this.onUploadPhoto}
                            onConfirmPhoto={this.onConfirmPhoto}
                            onClose={this.onClose}
                            onContinue={this.onContinue}
                            onChange={this.onChange}
                            onChangeNumber={this.onChangeNumber}
                            onChangeDateTime={this.onChangeDateTime}
                            onBlur={this.onBlur}
                            onToggle={this.onToggle}
                            onSubmit={this.onSubmit}
                            valid={this.isValid()}
                            onCancelPhoto = {this.onCancelPhoto}
                            onSelectChallenge={this.onSelectChallenge}
                            onSelectCategory={this.onSelectCategory} 
                            inputText={this.state.inputText} />
                    }
                </LogCards>;
                    
    }

}

export default withRouter(connect()(LogCardContainer));



// WEBPACK FOOTER //
// ./src/modules/logs/LogCardContainer.js